export default __webpack_public_path__ + "static/media/ic_gmx_40.4b74a9ba.svg";